"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RULE_TYPE = exports.RULE_TYPE = 1;
var KEYFRAME_TYPE = exports.KEYFRAME_TYPE = 2;
var FONT_TYPE = exports.FONT_TYPE = 3;
var STATIC_TYPE = exports.STATIC_TYPE = 4;
var CLEAR_TYPE = exports.CLEAR_TYPE = 5;


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/styleTypes.js
// module id = 440
// module chunks = 0